import styled from 'styled-components';

import colors from 'themes/Main';

const { darkBlue, gray01 } = colors;

export const HistoryTitle = styled.h3`
  color: ${darkBlue};
  font-size: 24px;
  font-weight: 700;
  line-height: 133%;
  position: relative;
  top: -16px;
`;

export const History = styled.div`
  margin-top: -16px;
  width: 100%;
`;

export const OddHours = styled.small`
  color: ${gray01};
  display: block;
  font-weight: 600;
  margin-bottom: 16px;
  opacity: 0.6;
`;

export const HistoryItem = styled.p`
  color: ${gray01};
  padding: 0 4px;

  &:first-child {
    margin-top: 24px;
  }

  &:last-child {
    margin-bottom: 24px;
  }

  span {
    position: relative;
    font-weight: 700;

    &:first-child {
      right: 4px;
    }

    &:last-child {
      left: 4px;
    }
  }
`;

export const HistoryTotally = styled.div`
  align-items: center;
  display: flex;
`;

export const TotallyFeatured = styled.span`
  color: ${darkBlue};
  font-weight: 700;
`;

export const TotallyHours = styled.p`
  color: ${gray01};
  font-weight: 700;
  margin-bottom: 0;
  margin-left: 8px;
`;

export const HistoryActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;
